module.exports = __webpack_public_path__ + "static/media/antigua-beaches-10.c98c6632.jpg";